// removed by extract-text-webpack-plugin
module.exports = {"container":"container___3ATLU","url":"url___34G2w"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/NotFound/NotFound.module.scss
// module id = IfL1
// module chunks = 64